import React from 'react';
import { Button, Space } from 'antd';
import { T206Mode } from '../hooks/useT206Mode';

interface ActionBarProps {
  mode: T206Mode;
  hasCurrent: boolean;
  loading: boolean;
  onAdd: () => void;
  onSave: () => void;
  onEdit: () => void;
  onCancel: () => void;
  onDelete: () => void;
  onSearch: () => void;
}

const ActionBar: React.FC<ActionBarProps> = ({
  mode,
  hasCurrent,
  loading,
  onAdd,
  onSave,
  onEdit,
  onCancel,
  onDelete,
  onSearch,
}) => {
  const isEditing = mode !== 'browse';

  return (
    <Space size="small" wrap>
      {!isEditing && (
        <Button type="primary" size="small" onClick={onAdd} loading={loading}>
          新增
        </Button>
      )}
      {isEditing && (
        <Button type="primary" size="small" onClick={onSave} loading={loading}>
          儲存
        </Button>
      )}
      {!isEditing && hasCurrent && (
        <Button size="small" onClick={onEdit} loading={loading}>
          修改
        </Button>
      )}
      {isEditing && (
        <Button size="small" onClick={onCancel} disabled={loading}>
          取消
        </Button>
      )}
      {!isEditing && hasCurrent && (
        <Button size="small" danger onClick={onDelete} loading={loading}>
          刪除
        </Button>
      )}
      {!isEditing && (
        <Button size="small" onClick={onSearch} loading={loading}>
          查詢
        </Button>
      )}
    </Space>
  );
};

export default ActionBar;
